import DefaultLayout from '@/Layouts/DefaultLayout';
import { lazy } from 'react';
import { LoginRoutes } from '@/features/auth/routes/routes';
import { AuthInitializer } from '@/features/auth/guard/authInitializer';
import { BookingsRoutes } from '@/features/bookings/routes/routes';
import { ReportsRoutes } from '@/features/reports/routes/routes';
import { FinanceRoutes } from '@/features/finance/routes/routes';
import { CheckupRoutes } from '@/features/checkup/routes/routes';
import { SettingRoutes } from '@/features/setting/routes/routes';
import { RouteErrorPage } from '@repo/ui/components/errors';

const Home = lazy(() => import('@/core/global-pages/Home'));
const NotFound = lazy(() => import('@/core/global-pages/NotFound'));
const ServerError = lazy(() => import('@/core/global-pages/ServerError'));

const routes = [
    {
        path: '/',
        element: (
            <AuthInitializer>
                <DefaultLayout />
            </AuthInitializer>
        ),
        errorElement: <RouteErrorPage />,
        children: [
            { index: true, element: <Home /> },
            {
                path: '/500',
                element: <ServerError />,
            },
            ...BookingsRoutes,
            ...ReportsRoutes,
            ...FinanceRoutes,
            ...CheckupRoutes,
            ...SettingRoutes,
            { path: '*', element: <NotFound /> },
        ],
    },
    ...LoginRoutes,
    { path: '/500', element: <ServerError />, errorElement: <RouteErrorPage /> },
    { path: '*', element: <NotFound />, errorElement: <RouteErrorPage /> },
];

export { routes };
